export const scrollToById = (id: string, args?: ScrollIntoViewOptions) => {
  const element = document.getElementById(id);

  if (element) {
    element.scrollIntoView({ behavior: 'smooth', ...args });
  } else {
    console.warn(`Element with id '${id}' not found.`);
  }
};
